import { getEnabledAccountsByIds } from '../services/accounts/accountsService';
import { getEnabledCommoditiesByIds } from '../services/commodities/commoditiesService';
import { getEnabledContractsByIds } from '../services/contracts/contractsService';
import { getEnabledDriversByIds } from '../services/drivers/driversService';
import { getEnabledHauliersByIds } from '../services/hauliers/hauliersService';
import { getEnabledLaAreasByIds } from '../services/laAreas/laAreaService';
import { getEnabledLocationsByIds } from '../services/locations/locationsService';
import { getEnabledDepotsByIds } from '../services/depots/depotsService';
import { getEnabledShipsByIds } from '../services/ships/shipsService';
import { normalizeByIdsRows } from './entityListRowCache';

function wrap(fetcher) {
    return async (ids) => normalizeByIdsRows(await fetcher(ids));
}

/** Grid-shaped byIds fetchers keyed by React Query list key. */
const FETCHERS = {
    accounts: wrap(getEnabledAccountsByIds),
    commodities: wrap(getEnabledCommoditiesByIds),
    contracts: wrap(getEnabledContractsByIds),
    drivers: wrap(getEnabledDriversByIds),
    hauliers: wrap(getEnabledHauliersByIds),
    laAreas: wrap(getEnabledLaAreasByIds),
    locations: wrap(getEnabledLocationsByIds),
    depots: wrap(getEnabledDepotsByIds),
    ships: wrap(getEnabledShipsByIds),
};

export function getEntityListRowFetcher(listQueryKey) {
    return FETCHERS[listQueryKey] ?? null;
}

export function extraListKeysForEntity(entityName, normalizedName) {
    if (entityName === 'Locations' || normalizedName === 'locations') {
        return ['depots'];
    }
    return [];
}
